import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=6c947e65&scoped=true"
import script from "./pie-chart.vue?vue&type=script&lang=js"
export * from "./pie-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c947e65",
  null
  
)

export default component.exports